import { Stack, Heading, Box } from 'braid-design-system';
import Youtube from 'react-youtube';

import * as styles from './style.css';

const FranchiseeStories = () => (
  <Stack space="medium">
    <Heading level="3" component="h2">
      Franchisee stories
    </Heading>

    <Box className={styles.container} borderRadius="large" overflow="hidden">
      <Youtube
        videoId="u4gc2zOtq5I"
        opts={{ height: '100%', width: '100%' }}
        className={styles.iframe}
      />
    </Box>
  </Stack>
);

export default FranchiseeStories;
